const locale = {
	DETAILS_SOCIALNETWORKS_FIELD_TYPE: 'Social Network Type',
	DETAILS_SOCIALNETWORKS_FIELD_DESCRIPTION: 'Description',
	DETAILS_SOCIALNETWORKS_FIELD_URL: 'URL'
};

export default locale;
